import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { SchoolProvider } from './contexts/SchoolContext';
import SandwichWizard from './components/SandwichWizard';
import AboutPage from './components/AboutPage';
import Login from './components/Login';
import SchoolSelect from './components/SchoolSelect';
import AdminDashboard from './components/AdminDashboard';
import MainAdminDashboard from './components/MainAdminDashboard';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Public Routes. The header (school name + logo) lives inside
                SandwichWizard rather than here — it needs the school's name
                from /api/public/options, which is Host-resolved per school
                (see AGENTS.md's "Schools are database-backed" section), so
                rendering it here before that fetch completes would either
                show a placeholder or hardcode one school's name. */}
            <Route path="/" element={
              <div className="container">
                <SandwichWizard />
              </div>
            } />

            {/* Marketing landing page — also served server-side at "/about"
                and for a bare base domain in production (see
                backend/middleware/school.go's landingPage), but that never
                gets hit by the CRA dev server's client-side routing, so
                this route is what makes SandwichWizard.js's "About Us"
                footer link actually work in dev. Keep the copy in sync
                with AboutPage.js's comment. */}
            <Route path="/about" element={
              <div className="container">
                <AboutPage />
              </div>
            } />

            <Route path="/login" element={<Login />} />

            {/* Post-login, pre-school-selection: pick which school to manage.
                Landing here (rather than assuming a school) is what makes
                the school choice an explicit, visible step instead of
                implicit state. */}
            <Route path="/admin" element={
              <ProtectedRoute>
                <SchoolProvider>
                  <SchoolSelect />
                </SchoolProvider>
              </ProtectedRoute>
            } />

            {/* FullAdmin-only global area: school creation, all-users
                management. Not scoped to any :schoolId — a separate route
                and shell rather than pages squeezed into the school
                dashboard. SchoolAdmins are redirected to /admin if they hit
                this URL directly (see ProtectedRoute's requireFullAdmin).
                Registered before /admin/:schoolId/* — "main" must never be
                a real school id (the backend also rejects it, alongside
                other reserved words like "schools"/"users"/"backup"; see
                AGENTS.md). */}
            <Route path="/admin/main/*" element={
              <ProtectedRoute requireFullAdmin>
                <SchoolProvider>
                  <MainAdminDashboard />
                </SchoolProvider>
              </ProtectedRoute>
            } />

            {/* The school is part of the URL from here down — bookmarkable,
                shareable, and unambiguous about which school's data is
                being viewed. See AdminDashboard.js. */}
            <Route path="/admin/:schoolId/*" element={
              <ProtectedRoute>
                <SchoolProvider>
                  <AdminDashboard />
                </SchoolProvider>
              </ProtectedRoute>
            } />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
